import { v4 as uuidV4 } from 'uuid'
import { Ref, ref, nextTick } from 'vue'
import { UploadEnums } from '@/enums/upload'
import { StringObject } from '@/types/public'
import { isAndrod, isAgriApp } from '@/utils/app'
import { UploadFileDataItem } from '@/types/public'
import { judgeFileUrlIsImage } from '@/utils/common'
import { uploadFileToIntegratedSystem } from '@/apis/public'

export function useUploadList(option?: {
  fileList: UploadFileDataItem[]
  onlyCheck?: boolean
  multiple?: boolean
  uploadTo?: string // 上传到哪个系统提供的接口
  useAction?: boolean // 是否使用actionsheet选择文件选择方式， 默认当做是true
}) {
  const videoUrl = ref('')
  const videoPreviewVisible = ref(false)
  const inputVm: Ref<HTMLInputElement | null> = ref(null)
  const inputAttrs: Ref<StringObject> = ref({})

  const uploadActions = [
    { name: '拍照', type: 'camera' },
    { name: '拍摄', type: 'camcorder' },
    { name: '系统文件', type: '.pdf,.txt,.doc,.docx,.xls,.xlsx,.csv,.zip' },
  ]
  const uploadActionShow = ref(false)
  function getNewItem() {
    return {
      uuid: uuidV4(),
      status: UploadEnums.Wait,
    }
  }

  function getDefaultFiles() {
    return [...(option?.fileList || []), option?.onlyCheck ? undefined : getNewItem()]
      .filter((val) => !!val)
      .map((item) => {
        return {
          ...item,
          uuid: item.uuid || uuidV4(),
        }
      })
  }
  const fileList: Ref<UploadFileDataItem[]> = ref(getDefaultFiles())

  const uploadHandle = (() => {
    if (option?.uploadTo === 'integrated') {
      return uploadFileToIntegratedSystem
    }
    return () => {
      console.log('未指定上传到的系统')
    }
  })()
  function addNewItem() {
    fileList.value.push(getNewItem())
  }
  function onUploadChange(data: UploadFileDataItem) {
    fileList.value = fileList.value.map((item) => {
      if (item.uuid === data.uuid) {
        return {
          ...data,
        }
      }
      return item
    })
  }
  function onDelete(data: UploadFileDataItem) {
    fileList.value = fileList.value.filter((item) => item.uuid !== data.uuid)
    if (fileList.value.length === 0) {
      addNewItem()
    }
  }
  function onBeforeStart() {
    if (option?.useAction === false) {
      inputVm.value?.click()
      return
    }
    uploadActionShow.value = true
  }

  function onActionSelect(data: any) {
    // 单选的话以xagshowfilechooser开头  多选的话用这个开头 xagshowfilechoosermultiple
    uploadActionShow.value = false
    const isAndroidAgriApp = isAgriApp && isAndrod
    if (isAndroidAgriApp) {
      // 农服需要特殊处理
      const proto = option?.multiple ? 'xagshowfilechoosermultiple' : 'xagshowfilechooser'
      if (data.type === 'camera') {
        inputAttrs.value = { accept: `${proto}/takephoto` }
      } else if (data.type === 'camcorder') {
        inputAttrs.value = { accept: `${proto}/recordvideo` }
      } else {
        inputAttrs.value = { accept: `${proto}/filechooser,${data.type}` }
      }
    } else {
      // 设置格式
      if (data.type === 'camera') {
        inputAttrs.value = { accept: 'image/*', capture: data.type }
      } else if (data.type === 'camcorder') {
        inputAttrs.value = { accept: 'video/*', capture: data.type }
      } else {
        inputAttrs.value = { accept: data.type }
      }
    }

    // 触发上传
    nextTick(() => {
      inputVm.value?.click()
    })
  }
  function onFileAdd(files: File[]) {
    fileList.value = fileList.value
      .filter((val) => val.status && val.status !== UploadEnums.Wait)
      .concat(
        files
          .filter((val) => val)
          .map((file) => {
            return {
              status: UploadEnums.WaitUpload,
              key: '',
              file,
              uuid: uuidV4(),
              guid: '',
            }
          })
      )
      .concat(getNewItem())
    nextTick(() => {
      if (inputVm.value) {
        inputVm.value.value = ''
      }
    })
  }

  function onPreview(data: UploadFileDataItem) {
    let indexValue = 0
    const validFiles = fileList.value.filter((item) => {
      return (
        item.status === UploadEnums.Success &&
        (item.url || item.file) &&
        judgeFileUrlIsImage(item.url || item.key || '')
      )
    })
    validFiles.some((item, index) => {
      if (item.uuid === data.uuid) {
        indexValue = index
      }
    })
    const result = {
      images: validFiles
        .map((item) => {
          if (item.url) {
            return item.url
          }
          if (item.file) {
            const blobUrl = URL.createObjectURL(item.file)
            return blobUrl
          }
          return ''
        })
        .filter((val) => val) as string[],
      startPosition: indexValue,
    }
    console.log('result', result)
    // showImagePreview(result)
  }
  function onPreviewVideo(data: UploadFileDataItem) {
    videoUrl.value = data?.url || (data?.file ? URL.createObjectURL(data.file) : '')
    if (videoUrl.value) {
      videoPreviewVisible.value = true
    }
  }
  // 清空文件
  function clearFileList() {
    fileList.value = []
  }
  // 重置上传
  function resetHandle() {
    fileList.value = getDefaultFiles()
  }

  return {
    fileList,
    onUploadChange,
    onDelete,
    onBeforeStart,
    inputVm,
    onFileAdd,
    onPreview,
    uploadActions,
    uploadActionShow,
    onActionSelect,
    inputAttrs,
    onPreviewVideo,
    videoUrl,
    videoPreviewVisible,
    uploadHandle,
    clearFileList,
    resetHandle,
  }
}
